import { getToken } from '@helpscout/hsds-tokens/getToken'

export type ButtonSizeConfig = {
  borderRadius: string
  fontSize: number
  height: string
  iconGap: string
  padding: string
  paddingIconLarge: string
  paddingIconSmall: string
  shortcutSize: string
  shortcutFontSize: string
}

export type ButtonConfig = {
  borderRadius: string
  fontWeight: number
  iconOffset: number
  size: {
    xxl: ButtonSizeConfig
    xl: ButtonSizeConfig
    lg: ButtonSizeConfig
    md: ButtonSizeConfig
    sm: ButtonSizeConfig
    xs: ButtonSizeConfig
    xxs: ButtonSizeConfig
  }
}

const xxl: ButtonSizeConfig = {
  borderRadius: getToken('button.radius.default'),
  fontSize: 14,
  height: '50px',
  iconGap: '5px',
  padding: '40px',
  paddingIconLarge: '25px',
  paddingIconSmall: '20px',
  shortcutSize: '24px',
  shortcutFontSize: '12px',
}
const xl: ButtonSizeConfig = {
  borderRadius: getToken('button.radius.default'),
  fontSize: 14,
  height: '44px',
  iconGap: '5px',
  padding: '30px',
  paddingIconLarge: '20px',
  paddingIconSmall: '15px',
  shortcutSize: '24px',
  shortcutFontSize: '12px',
}

const lg: ButtonSizeConfig = {
  borderRadius: getToken('button.radius.default'),
  fontSize: 14,
  height: '40px',
  iconGap: '2px',
  padding: '25px',
  paddingIconLarge: '15px',
  paddingIconSmall: '10px',
  shortcutSize: '24px',
  shortcutFontSize: '12px',
}

const md: ButtonSizeConfig = {
  borderRadius: getToken('button.radius.default'),
  fontSize: 13,
  height: '36px',
  iconGap: '5px',
  padding: '20px',
  paddingIconLarge: '12px',
  paddingIconSmall: '8px',
  shortcutSize: '24px',
  shortcutFontSize: '12px',
}

const sm: ButtonSizeConfig = {
  borderRadius: getToken('button.radius.default'),
  fontSize: 13,
  height: '32px',
  iconGap: '2px',
  padding: '12px',
  paddingIconLarge: '12px',
  paddingIconSmall: '4px',
  shortcutSize: '20px',
  shortcutFontSize: '12px',
}

const xs: ButtonSizeConfig = {
  borderRadius: getToken('button.radius.small'),
  fontSize: 13,
  height: '24px',
  iconGap: '0px',
  padding: '10px',
  paddingIconLarge: '10px',
  paddingIconSmall: '5px',
  shortcutSize: '16px',
  shortcutFontSize: '11px',
}

const xxs: ButtonSizeConfig = {
  borderRadius: getToken('button.radius.small'),
  fontSize: 11,
  height: '20px',
  iconGap: '-2px',
  padding: '6px',
  paddingIconLarge: '8px',
  paddingIconSmall: '0px',
  shortcutSize: '14px',
  shortcutFontSize: '10px',
}

const config: ButtonConfig = {
  borderRadius: getToken('button.radius.small'),
  fontWeight: 500,
  iconOffset: 4,
  size: {
    xxl,
    xl,
    lg,
    md,
    sm,
    xs,
    xxs,
  },
}

export default config
